import { render, staticRenderFns } from "./MallForm.vue?vue&type=template&id=81fe33ce&"
import script from "./MallForm.vue?vue&type=script&lang=js&"
export * from "./MallForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports